import type { IconOwnProps } from '@ps/isp-web-component-library';
import { Cash } from '@ps/isp-web-component-library/icons/Cash';
import { CloseSmall } from '@ps/isp-web-component-library/icons/CloseSmall';
import { FreeBetSb } from '@ps/isp-web-component-library/icons/FreeBetSb';
import { Gift } from '@ps/isp-web-component-library/icons/Gift';
import type {
  MultipleAvailableOpportunity,
  SingleAvailableOpportunity
} from '@ps/isp-web-services-types';

import type { StarsWebExtraWallet } from '@swf/core/models/sports/extraWallets/types';
import {
  getIsWalletBonusCash,
  getIsWalletFreeBet
} from '@swf/core/models/sports/extraWallets/utils/getIsWallet';

type ExtraWalletsMap = Record<number, StarsWebExtraWallet>;

export const getPromotionPickerIcon = (
  wallets: StarsWebExtraWallet[],
  opportunity: SingleAvailableOpportunity | MultipleAvailableOpportunity,
  isPromotionPickerOpen: boolean,
  hasFreeBetApplied: boolean,
  hasBonusCashApplied: boolean
): Pick<IconOwnProps, 'icon' | 'size'> => {
  if (isPromotionPickerOpen) {
    return { icon: CloseSmall, size: 'x1' };
  }

  const extraWalletsMap: ExtraWalletsMap = wallets.reduce((acc, cur) => {
    const walletMap = {
      [Number(cur.id)]: cur
    };
    return { ...acc, ...walletMap };
  }, {});

  const showFreeBetIcon =
    hasFreeBetApplied ||
    opportunity.applicableWallets?.every((walletId) =>
      getIsWalletFreeBet(extraWalletsMap[walletId])
    );

  if (showFreeBetIcon) {
    return { icon: FreeBetSb, size: 'sm' };
  }

  const showBonusCashIcon =
    hasBonusCashApplied ||
    opportunity.applicableWallets?.every((walletId) =>
      getIsWalletBonusCash(extraWalletsMap[walletId])
    );

  if (showBonusCashIcon) {
    return { icon: Cash, size: 'x1' };
  }

  return { icon: Gift, size: 'x1' };
};
